import { SelectOption, useWatch } from '@kanda-libs/ks-component-ts';
import { FinanceRate } from '@kanda-libs/ks-frontend-services';
import { pipe } from 'fp-ts/lib/function';
import { useMemo } from 'react';
import {
  getBnplDepositOptions,
  getDepositOptions,
  getDurationsForApr,
  getDurationsForBnpl,
  mapBnplDurationsToSelectOptions,
  mapDurationsToSelectOptions,
} from './helpers';

export interface JobFormHook {
  price: number;
  aprLabel: string;
  durations: SelectOption[];
  deposits: SelectOption[];
}

export default function useJobForm(
  rates: FinanceRate[],
  bnplRates?: FinanceRate[],
): JobFormHook {
  const [apr, price, duration] = useWatch({
    name: ['apr', 'price', 'duration'],
  });

  const aprLabel = useMemo(() => {
    if (apr === 'BNPL') return 'Buy Now, Pay Later';
    if (apr === '0') return 'Interest Free';
    return 'Interest Bearing';
  }, [apr]);

  const durations = useMemo(() => {
    if (apr === 'BNPL')
      return pipe(
        getDurationsForBnpl(bnplRates),
        mapBnplDurationsToSelectOptions,
      );
    return pipe(getDurationsForApr(apr, rates), mapDurationsToSelectOptions);
  }, [apr, rates, bnplRates]);

  const deposits = useMemo(() => {
    if (apr === 'BNPL')
      return getBnplDepositOptions(price, duration, bnplRates);
    return getDepositOptions(price, apr, rates);
  }, [price, apr, rates, bnplRates, duration]);

  return { price, aprLabel, durations, deposits };
}
